function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// +----------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.net All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +----------------------------------------------------------------------
// | Author: CNXRC Team <admin@cnxrc.net>
// +----------------------------------------------------------------------

import { login as _login, logout, getInfo as _getInfo } from '@/api/user';
import { businessLoginApi, businessGetAdminInfoByTokenApi, businessLogoutApi, businessGetMenusApi, regionLoginApi, regionGetAdminInfoByTokenApi, regionLogoutApi, regionGetMenusApi } from '@/api/area';
import { getToken, setToken as _setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import { isLoginApi } from '@/api/sms';
import Cookies from 'js-cookie';
import { Loading } from 'element-ui';
import * as roleApi from '@/api/roleApi.js';
import { formatFlatteningRoutes } from '@/utils/system.js';
import { isPlatform, getAdminModule, getRoutePrefix } from '@/utils/settingMer';
var moduleApiMap = {
  business: {
    login: businessLoginApi,
    getInfo: businessGetAdminInfoByTokenApi,
    logout: businessLogoutApi,
    getMenus: businessGetMenusApi
  },
  region: {
    login: regionLoginApi,
    getInfo: regionGetAdminInfoByTokenApi,
    logout: regionLogoutApi,
    getMenus: regionGetMenusApi
  }
};
function getModuleApis() {
  return moduleApiMap[getAdminModule()] || moduleApiMap.business;
}
function getModuleStorageKey(name) {
  var moduleName = getAdminModule();
  return "".concat(moduleName.charAt(0).toUpperCase()).concat(moduleName.slice(1), "_Admin_").concat(name);
}
function getMenusName() {
  if (isPlatform) return JSON.parse(localStorage.getItem('MerPlatAdmin_MenuList')) || [];
  var menuList = localStorage.getItem(getModuleStorageKey('MenuList'));
  return menuList ? JSON.parse(menuList) : [];
}
function normalizeModuleMenuPath(menuList) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getRoutePrefix();
  var moduleName = prefix.slice(1);
  return (menuList || []).map(function (item) {
    var menu = _objectSpread({}, item);
    if (menu.path && menu.path.startsWith('/') && menu.path.split('/')[1] !== moduleName) {
      menu.path = menu.path === '/' ? prefix : prefix + menu.path;
    }
    if (menu.children && menu.children.length) {
      menu.children = normalizeModuleMenuPath(menu.children, prefix);
    }
    return menu;
  });
}
var state = {
  token: getToken(),
  moduleToken: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  moduleRoles: [],
  isLogin: Cookies.get('isLogin'),
  permissions: [],
  modulePermissions: [],
  userInfo: null,
  // 存储完整的平台用户信息
  moduleUserInfo: null,
  // 存储完整的商户/区域用户信息
  captcha: {
    captchaVerification: '',
    secretKey: '',
    token: ''
  },
  //滑块验证token
  // 菜单数据
  menuList: getMenusName(),
  oneLvMenus: [],
  moduleOneLvMenus: [],
  oneLvRoutes: JSON.parse(localStorage.getItem('MerPlatAdmin_oneLvRoutes')) || [],
  moduleOneLvRoutes: JSON.parse(localStorage.getItem(getModuleStorageKey('oneLvRoutes'))) || [],
  childMenuList: [],
  moduleChildMenuList: []
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    if (isPlatform) state.token = token;else state.moduleToken = token;
  },
  SET_ISLOGIN: function SET_ISLOGIN(state, isLogin) {
    state.isLogin = isLogin;
    Cookies.set('isLogin', isLogin);
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    if (isPlatform) state.roles = roles;else state.moduleRoles = roles;
  },
  SET_PERMISSIONS: function SET_PERMISSIONS(state, permissions) {
    if (isPlatform) state.permissions = permissions;else state.modulePermissions = permissions;
  },
  SET_USER_INFO: function SET_USER_INFO(state, userInfo) {
    if (isPlatform) state.userInfo = userInfo;else state.moduleUserInfo = userInfo;
  },
  SET_CAPTCHA: function SET_CAPTCHA(state, captcha) {
    state.captcha = captcha;
  },
  SET_MENU_LIST: function SET_MENU_LIST(state, menuList) {
    if (isPlatform) {
      state.menuList = menuList;
      localStorage.setItem('MerPlatAdmin_MenuList', JSON.stringify(menuList));
    } else {
      state.menuList = normalizeModuleMenuPath(menuList);
      localStorage.setItem(getModuleStorageKey('MenuList'), JSON.stringify(state.menuList));
    }
  },
  setOneLvMenus: function setOneLvMenus(state, oneLvMenus) {
    if (isPlatform) {
      state.oneLvMenus = oneLvMenus;
    } else {
      state.moduleOneLvMenus = normalizeModuleMenuPath(oneLvMenus);
    }
  },
  setOneLvRoute: function setOneLvRoute(state, oneLvRoutes) {
    if (isPlatform) state.oneLvRoutes = oneLvRoutes;else state.moduleOneLvRoutes = oneLvRoutes;
  },
  childMenuList: function childMenuList(state, list) {
    if (isPlatform) state.childMenuList = list;else state.moduleChildMenuList = list;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    Loading.service();
    return new Promise(function (resolve, reject) {
      var loginApi = isPlatform ? _login : getModuleApis().login;
      loginApi(userInfo).then(function (data) {
        var loadingInstance = Loading.service();
        loadingInstance.close();
        commit('SET_TOKEN', data.token);
        Cookies.set(isPlatform ? 'JavaPlatInfo' : "".concat(getAdminModule(), "JavaPlatInfo"), JSON.stringify(data));
        _setToken(data.token);
        commit('menu/clearAll', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 短信是否登录
  isLogin: function isLogin(_ref2) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      isLoginApi().then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                commit('SET_ISLOGIN', res.isLogin);
                resolve(res);
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (res) {
        commit('SET_ISLOGIN', false);
        reject(res);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      var getUserInfoApi = isPlatform ? function () {
        return _getInfo(state.token);
      } : getModuleApis().getInfo;
      getUserInfoApi().then(function (data) {
        if (!data) reject('Verification failed, please Login again.');
        var roles = data.roles,
          account = data.account;
        if (!roles || roles.length <= 0) reject('getInfo: roles must be a non-null array!');
        commit('SET_ROLES', roles);
        commit('SET_NAME', account);
        commit('SET_AVATAR', 'http://kaifa.cnxrc.net/system/images/admin_logo.png');
        commit('SET_INTRODUCTION', 'cnxrc admin');
        commit('SET_PERMISSIONS', data.permissionsList);
        commit('SET_USER_INFO', data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  handleLogout: function handleLogout(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state,
      dispatch = _ref5.dispatch;
    Loading.service();
    return new Promise(function (resolve, reject) {
      var moduleName = getAdminModule();
      var logoutApi = isPlatform ? function () {
        return logout(state.token);
      } : getModuleApis().logout;
      logoutApi().then(function () {
        var loadingInstance = Loading.service();
        loadingInstance.close();
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        commit('SET_PERMISSIONS', []);
        removeToken();
        Cookies.remove('storeStaffList');
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        if (isPlatform) {
          Cookies.remove('JavaPlatInfo');
          sessionStorage.removeItem('token');
        } else {
          Cookies.remove("".concat(moduleName, "JavaPlatInfo"));
        }
        resetRouter();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      commit('menu/clearAll', null, {
        root: true
      });
      resolve();
    });
  },
  // 设置token
  setToken: function setToken(_ref7, data) {
    var commit = _ref7.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', data.token);
      Cookies.set(isPlatform ? 'JavaPlatInfo' : "".concat(getAdminModule(), "JavaPlatInfo"), JSON.stringify(data));
      _setToken(data.token);
      resolve();
    });
  },
  getMenus: function getMenus(_ref8) {
    var commit = _ref8.commit;
    function formatTwoStageRoutes(arr) {
      if (arr.length <= 0) return false;
      var newArr = [];
      var cacheList = [];
      arr.forEach(function (v) {
        if (v && v.meta && v.meta.keepAlive) {
          newArr.push(_objectSpread({}, v));
          cacheList.push(v.name);
        }
      });
      return newArr;
    }
    return new Promise(/*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resolve) {
        var getMenuApi, accessRoutes, arr, routes;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              getMenuApi = isPlatform ? roleApi.menuListApi : getModuleApis().getMenus;
              _context2.n = 1;
              return getMenuApi();
            case 1:
              accessRoutes = _context2.v;
              commit('SET_MENU_LIST', accessRoutes);
              arr = formatFlatteningRoutes(router.options.routes);
              formatTwoStageRoutes(arr);
              routes = formatFlatteningRoutes(accessRoutes);
              if (isPlatform) {
                localStorage.setItem('MerPlatAdmin_oneLvRoutes', JSON.stringify(routes));
                commit('setOneLvMenus', arr);
                commit('setOneLvRoute', routes);
              } else {
                routes = normalizeModuleMenuPath(routes);
                localStorage.setItem(getModuleStorageKey('oneLvRoutes'), JSON.stringify(routes));
                commit('setOneLvRoute', routes);
              }
              resolve(accessRoutes);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref9.apply(this, arguments);
      };
    }());
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};